import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/app/recipe/[slug]/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/app/recipe/[slug]/CurrentRecipeDispatcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/app/recipe/[slug]/FuzzyMatchTracker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/recipes/components/ad.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/article/ArticleBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/article/ArticleTile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/EzoicDisabled.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/EzoicEnabled.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/carouselSingle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/ChicoryAisle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/ChicoryButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/recipes/components/recipe/DepthTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/RecipeBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/RecipeDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/RecipeDirectionsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/RecipeGridItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/RecipeIngredientList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/RecipeShareActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/RecipeTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/RecipeYieldTime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/recipe/tagDisplay.tsx");
